export default async ({ $api, store }) => {
  try {
    const motorInsurers = await $api('util/motor_insurers');

    const protectionInsurers = await $api('providers/providers', {'product': 'life_insurance'});
    const filteredProtectionInsurers = protectionInsurers.map(item => {
      return {
        name: item.name,
        id: item.id
      };
    });
    filteredProtectionInsurers.push({ name: 'Other - Not listed', id: 'other' });

    const providers = [
      {
        motor: motorInsurers,
        protection: filteredProtectionInsurers
      }
    ];
    providers[0].motor.shift();
    store.commit('providers/setList', providers);
  } catch (e) {
    console.log(e);
  };
};
